// extracted by mini-css-extract-plugin
export default {"container":"MyFavs_container__er5DL","title":"MyFavs_title__axlQu"};